import van from 'vanjs-core';
import {BigTag} from "../../components/big-tag";
import {
    energySaved,
    areaPlant,
    nominalPower,
    energyAmount,
    energyTotalAmount,
    powerProductionValue,
    percentageText,
    smGraphValue,
    chart,
    energyUnit
} from "../../state-variables";
import {Page1NominalPowerAreaPlantSm} from "../../components/page1/page-specific-tags";
import {drawChart} from "../../chartjs-config";
import {fetchChartData} from "../../state-variables";

const {div, img, span, canvas} = van.tags;
const {svg, circle, text} = van.tags("http://www.w3.org/2000/svg");

// Hlavní obsahové okno na 3. obrazovce
export const MainContent = () => {

    // Chart canvas
    const chartCanvas = canvas();
    const context = chartCanvas.getContext("2d");

    // Chart init
    queueMicrotask(() => {
        document.fonts.ready.then(() => {
            chart.val = drawChart(context, chartCanvas);
            fetchChartData();
            /*window.addEventListener("resize", () => {
                if (chart.val) {
                    chart.val.destroy();
                    chart.val = drawChart(context, chartCanvas);
                }
            });*/
        });
    });

    return div({class: "w-100 main-content m2-part p-0 py-mn m-0 justify-content-center d-flex flex-column main-content-radius"},
        div({class: "w-100 row container-fluid p-0 m-0", style: "z-index: 1; height: fit-content;"},
            div({class: "col-lg-8 col-md-12 d-flex flex-column align-items-center bg-light-see-through justify-content-center section-padding section-padding-y0"},
                div({class: "d-flex flex-row justify-content-center w-100"},
                    span({class: "chart-title text-dark-blue me-3"}, "PRODUCTION OVERVIEW"),
                    span({class: "chart-title text-light-blue"}, "PŘEHLED PRODUKCE"),
                ),
                div({class: "chart-container w-100 d-flex flex-column align-items-center", id: "chart"},
                    chartCanvas,
                ),

                div({class: "item d-flex flex-row align-items-center w-100 justify-content-between mobile-column"},
                    div({class: "item d-flex flex-column align-items-center"},
                        BigTag("DENNÍ PRODUKCE", "DALY ENERGY", energyAmount, energyUnit, false, true),
                    ),
                    div({class: "item d-flex flex-column align-items-center"},
                        BigTag("CELKOVÁ PRODUKCE", "TOTAL ENERGY", energyTotalAmount, "MWh", false, true),
                    ),
                ),
            ),
            div({class: "col-lg-4 col-md-12 d-flex flex-column align-items-center bg-light-see-through justify-content-between section-padding section-padding-y0"},
                div({class: "section-aligner"},
                    div({class: "graph-container sm circular-graph-padding"},
                        svg({width: "200", height: "200", viewBox: "-25 -25 250 250", version: "1.1", xmlns: "http://www.w3.org/2000/svg", style: "transform:rotate(110deg)"},
                            circle({"r": "80", cx: "100", cy: "100", fill: "transparent", stroke: "#0066AE", "stroke-width": "10px", "stroke-linecap": "round", "stroke-dashoffset": "65px", "stroke-dasharray": "512px"}),
                            circle({"r": "80", cx: "100", cy: "100", stroke: "#45C0EA", "stroke-width": "11px", "stroke-linecap": "round", "stroke-dashoffset": () => smGraphValue.val.toString() + "px", fill: "transparent", "stroke-dasharray": "565.48px"}),
                            text({"x": "-50%", "y": "30%", fill: "#45C0EA", "text-anchor": "middle", "font-size": "2.6rem", "font-weight": "500", style: "transform:rotate(250deg)"},
                                () => percentageText.val.toString() + "%",
                            ),
                        ),
                    ),


                    div({class: "item d-flex flex-column align-items-center w-100"},
                        BigTag("AKTUÁLNÍ PRODUKCE", "POWER PRODUCTION", powerProductionValue, "kW", false, false, true, "mobile-row-tag"),
                    ),
                    div({class: "item d-flex flex-column align-items-center w-100"},
                        BigTag("ZADRŽENO CO2", "TOTAL CO2 SAVED", energySaved, "ton", true),
                    ),
                    div({class: "mobile-spacer"}),
                    Page1NominalPowerAreaPlantSm(nominalPower, areaPlant),
                ),
            ),
        ),
    );
};